import { Switch } from '@art-of-hospitality-solutions-llc/ui-kit/components/switch';

interface ToggleFieldProps {
  title?: string;
  description?: string;
  value?: boolean;
  onChange: (value: boolean) => void;
}

/** Row layout: label + helper text on the left, switch on the right. */
export default function ToggleField({
  title,
  description,
  value,
  onChange,
}: ToggleFieldProps) {
  return (
    <div className="flex items-start justify-between gap-3">
      <div>
        <div className="text-sm">{title}</div>
        {description && (
          <div className="text-xs text-zinc-500">{description}</div>
        )}
      </div>
      <Switch checked={value ?? false} onCheckedChange={onChange} />
    </div>
  );
}
